<app-header></app-header>

<div class="vincent_title_block vincent_corners">
    <div class="vincent_inner_text">
        <h1>{{"order_details" | translate}}</h1>
    </div>
</div>

<div class="vincent_container vincent_typography">
    <div class="row gutters">
        <div class="col-lg-12 col-md-12 col-sm-12 vincent_content">
            <table class="vincent_cart">
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>{{"picked" | translate}}</th>
                        <th><span>{{"price" | translate}}</span></th>
                        <th>{{"amount" | translate}}</th>
                        <th><span>{{"total" | translate}}</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="vincent_cart_item" *ngFor="let info of order;index as i">
                        <td>
                            <a class="vincent_button vincent_button_background" (click)="update(i)">{{"save_amount" | translate}}</a>
                            <div class="alert alert-primary cus_success" role="alert" style="display: none;" id="updated">
                                {{"amount_has_been_saved" | translate}}
                             </div>
                        </td>
                        <td>
                            <a class="vincent_product-remove" (click)="delete(i)"> × </a>
                            <div class="alert alert-danger cus_error" role="alert" style="display: none;" id="removed">
                                {{"done_removing" | translate}}
                             </div>
                        </td>
                        <td class="vincent_product-thumbnail">
                            <img [src]="info.photo">
                        </td>
                        <td class="vincent_product-name" data-title="Product" *ngIf="title_en == true">
                            {{info.title}}
                        </td>
                        <td class="vincent_product-name" data-title="Product" *ngIf="title_ar == true">
                            {{info.title_ar}}
                        </td>
                        <td class="vincent_product-price" data-title="Price">
                            <span> {{"sar" | translate}} - {{info.price}}</span>
                        </td>
                        <td  class="vincent_product-quantity"  data-title="Quantity">
                            <input type="text" value="1" name="quantity" class="vincent_quantity" [(ngModel)]="info.amount">
                        </td>
                        <td class="vincent_product-subtotal" data-title="Total">
                            <span>  {{"sar" | translate}}- {{info.price * info.amount}}</span>
                        <span *ngIf="sum == true">{{recieve(info.price * info.amount)}}</span>
                        </td>            
                        <p></p>        

                    </tr>

                    <tr class="vincent_cart_actions">
                        <td colspan="6">
                                <p class="totals left">{{"order_length" | translate}} - {{length}}</p>	
                        </td>
                        <td colspan="6">	
                            <button class="vincent_update_cart" routerLink="/menu">{{"update_order" | translate}}</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="vincent_cart_totals" style="float: right;">
                <h5 class="right">{{"pricing_section" | translate}}</h5>
                <table class="table-cus">
                    <tbody>
                        <tr>
                            <td class="right">
                                 <p class="xtotal"> {{"total" | translate}} = {{totalll}} / {{"sar" | translate}} </p>
                            </td>
                        </tr>
                        <tr>
                             <td><span class="xtotal"> {{"tax" | translate}} = {{tax}}</span></td>
                        </tr>
                        <tr>
                            <td><span class="xtotal"> {{"all" | translate}} = {{all}} / {{"sar" | translate}}</span></td>
                        </tr>
                        <!-- <td class="right">
                            <a class="xtotal" (click)="resum()" style="display: none;" id="recal"><mdb-icon fas icon="redo-alt"></mdb-icon> {{"recalculating_total" | translate}}  </a>
                       </td> -->
                    </tbody>
                </table>
                <button class="vincent_button vincent_button_background xbtn" id="ff" routerLink="/checkout" [disabled]="length == 0 && gocheck == true">{{"confirm_order" | translate}}</button>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>